module.exports = __webpack_public_path__ + "static/img/CM.d7508de4.png";